import { useEffect, useRef } from "react";

export function useTemporaryTitle(
  tempTitle: string,
  active: boolean
) {
  const originalTitle = useRef<string | null>(null);

  useEffect(() => {
    if (active) {
      if (originalTitle.current === null) {
        originalTitle.current = document.title;
      }
      document.title = tempTitle;
    } else if (originalTitle.current !== null) {
      document.title = originalTitle.current;
      originalTitle.current = null;
    }
  }, [active, tempTitle]);
}
